module.exports = __webpack_public_path__ + "img/bg25.fb67a4ab.jpg";